import { render } from "./BestServices.vue?vue&type=template&id=61bb01d0&scoped=true&ts=true"
import script from "./BestServices.vue?vue&type=script&lang=ts"
export * from "./BestServices.vue?vue&type=script&lang=ts"

import "./BestServices.vue?vue&type=style&index=0&id=61bb01d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bb01d0"]])

export default __exports__